import script from "./OpenLimits.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenLimits.vue?vue&type=script&setup=true&lang=js"

import "./OpenLimits.vue?vue&type=style&index=0&id=4a9ad45c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a9ad45c"]])

export default __exports__